import { render } from "./sdcInfo.vue?vue&type=template&id=0f94faea&scoped=true"
import script from "./sdcInfo.vue?vue&type=script&lang=js"
export * from "./sdcInfo.vue?vue&type=script&lang=js"

import "./sdcInfo.vue?vue&type=style&index=0&id=0f94faea&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f94faea"]])

export default __exports__